<div class="main-container container-primary">
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>
  <app-footer [links]="footerLinks" class="footer"></app-footer>
</div>
